var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-container"},[_c(_vm.homeComponent,{tag:"component",attrs:{"homeInfo":_vm.state.homeInfo,"expertConfig":_vm.state.expertConfig}}),_c('RightFixedPanel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }